<div class="term-toggle-container w-100">
  @if(data.leftText) {
    <span class="term-toggle-text" [class.disabled]="!!(data.readonly)">{{ data.leftText | translate }}</span>
  }

  <div class="term-toggle" [class.disabled]="!!(data.readonly)" [class.active]="data.selected">
    <input type="checkbox" [id]="inputId" [(ngModel)]="data.selected" (change)="processOnChange()" [disabled]="!!(data.readonly)"/>
    <label [for]="inputId"></label>
  </div>

  @if(data.rightText) {
    <span class="term-toggle-text" [class.disabled]="!!(data.readonly)">{{ data.rightText | translate }}</span>
    @if(data.additionalRightText) {
      <span class="term-toggle-save-text">{{ data.additionalRightText | translate }}</span>
    }
  }
</div>
